/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const LaunchStatusHy = {
    CarryOver: 'CarryOver',
    Outgoing: 'Outgoing',
    FirstHalf: 'FirstHalf',
    SecondHalf: 'SecondHalf'
} as const;
export type LaunchStatusHy = typeof LaunchStatusHy[keyof typeof LaunchStatusHy];


export function instanceOfLaunchStatusHy(value: any): boolean {
    for (const key in LaunchStatusHy) {
        if (Object.prototype.hasOwnProperty.call(LaunchStatusHy, key)) {
            if (LaunchStatusHy[key as keyof typeof LaunchStatusHy] === value) {
                return true;
            }
        }
    }
    return false;
}

export function LaunchStatusHyFromJSON(json: any): LaunchStatusHy {
    return LaunchStatusHyFromJSONTyped(json, false);
}

export function LaunchStatusHyFromJSONTyped(json: any, ignoreDiscriminator: boolean): LaunchStatusHy {
    return json as LaunchStatusHy;
}

export function LaunchStatusHyToJSON(value?: LaunchStatusHy | null): any {
    return value as any;
}

export function LaunchStatusHyToJSONTyped(value: any, ignoreDiscriminator: boolean): LaunchStatusHy {
    return value as LaunchStatusHy;
}

